import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolGroupModifyRequest } from "../../../services/SchoolGroupModifyRequest";
import { StringRequest } from "../../../services/StringRequest";
import { SysAdminService } from "../../../services/sysadmin.service";

@Component({
	selector: "app-manage-sctedit",
	templateUrl: "./manage-sctedit.component.html",
	styleUrls: ["./manage-sctedit.component.css"],
})
export class ManageSCTEditComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SelectedContainer = this.dialogConfig.data.SelectedContainer;

		this.Code = this.SelectedContainer.SchoolGroupCD;
		this.Name = this.SelectedContainer.SchoolGroupDesc;
		this.SchoolGroupID = this.SelectedContainer.SchoolGroupID;

		this.OriginalCode = this.SelectedContainer.SchoolGroupCD;
		this.OriginalName = this.SelectedContainer.SchoolGroupDesc;
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	SelectedContainer: any;

	SchoolGroupID: any;
	Code: any = "";
	Name: any = "";

	OriginalCode: any = "";
	OriginalName: any = "";

	errorMessage: any = "";

	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == undefined || this.Code == "") {
			this.errorMessage = "Enter a Code";
			return;
		}

		if (this.Code.length < 3) {
			this.errorMessage = "Code must be at least 3 characters";
			return;
		}

		if (this.Name == undefined || this.Name == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		if (this.Name.length < 3) {
			this.errorMessage = "Description must be at least 3 characters";
			return;
		}

		if (this.Code != this.OriginalCode) {
			//Code and Description must be unique
			this.CheckCode();
		} else {
			if (this.Name != this.OriginalName) {
				this.CheckDesc();
			} else {
				this.UpdateSchoolGroup();
			}
		}
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.sysAdminService.SchoolGroupCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Code already in use";
					return;
				} else {
					if (this.Name != this.OriginalName) {
						this.CheckDesc();
					} else {
						this.UpdateSchoolGroup();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Name,
		};

		var result = this.sysAdminService.SchoolGroupDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Description already in use";
					return;
				} else {
					this.UpdateSchoolGroup();
				}
			},
			(error) => {}
		);
	}

	UpdateSchoolGroup() {
		let parms: SchoolGroupModifyRequest = {
			SchoolGroupID: this.SchoolGroupID,
			Code: this.Code,
			Desc: this.Name,
		};

		var result = this.sysAdminService.SchoolGroupModify(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Container was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the School Container",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////
}
